import React, { useState, useEffect, useRef  } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '../language/LanguageContext';
import Logo from '../images/BB.png';
import Bell from '../images/bell.png';
import { FaBars, FaUser, FaSignOutAlt, FaHome, FaClipboardList,  FaTimes , FaRupeeSign, FaQrcode , FaFileInvoice } from 'react-icons/fa';


function SupplierHeader() {
  const location = useLocation();
  const navigate = useNavigate();
  const { language } = useLanguage();
  const [menuOpen, setMenuOpen] = useState(false);
  const [NotificationsCount , setNotificationsCount] = useState(0);
  const [showQrScanner, setShowQrScanner] = useState(false);
  const [cameraError, setCameraError] = useState(null);
  const videoRef = useRef(null);

  useEffect(() => {
    GetAllNotifications();
  }, []);

  // Content translations
 const content = {
  english: {
    home: "Home",
    orders: "Orders",
    rfqs: "RFQs",
    payments: "Payments",
    profile: "Profile",
    logout: "Logout"
  },
  telugu: {
    home: "హోమ్",
    orders: "ఆర్డర్లు",
    rfqs: "ఆర్‌ఎఫ్‌క్యూలు",
    payments: "చెల్లింపులు",
    profile: "ప్రొఫైల్",
    logout: "లాగ్అవుట్"
  }
};

  const t = content[language];

    const GetAllNotifications = async () => {
    try {
      // Parse vendorData from localStorage
      const vendorDataString = localStorage.getItem('vendorData');
      if (!vendorDataString) {
        console.error('No vendor data found in localStorage');
        return;
      }

      const vendorData = JSON.parse(vendorDataString);
      const token = vendorData.token;

      // Fetch notifications
      const response = await fetch(
        `${process.env.REACT_APP_FORE_NOTIFICATIONS}get-notifications-count?user_id=${vendorData.id}&status=unread&channel=push`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token,
          },
        }
      );

      const data = await response.json();
      console.log('Notifications data:', data);

      if (data.success) {
        setNotificationsCount(data.count);
      } else {
        console.warn('No valid notifications data received');
      }
    } catch (error) {
      console.error('Error fetching Notifications:', error);
    } 
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleLogout = () => {
    localStorage.removeItem('vendorData');
    localStorage.removeItem('token');
    navigate('/supplier');
  };

 const checkDeviceCapabilities = async () => {
  try {
    // Check if mediaDevices is supported
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      throw new Error('Media devices not supported');
    }

    // List available devices
    const devices = await navigator.mediaDevices.enumerateDevices();
    const videoDevices = devices.filter(device => device.kind === 'videoinput');
    
    console.log('Available video devices:', videoDevices);

    if (videoDevices.length === 0) {
      throw new Error('No video input devices found');
    }

    return videoDevices;
  } catch (error) {
    console.error('Device capability check failed:', error);
    throw error;
  }
};

const handleQrCodeClick = async () => {
  // Reset any previous errors
  setCameraError(null);
  setShowQrScanner(true);

  try {
    // First, check device capabilities
    await checkDeviceCapabilities();

    // Request camera permissions
    const stream = await navigator.mediaDevices.getUserMedia({
      video: {
        facingMode: "environment", // Prefer back camera
        width: { ideal: 1280 },
        height: { ideal: 720 }
      }
    });

    if (videoRef.current) {
      videoRef.current.srcObject = stream;
      
      // Wait for metadata to load
      videoRef.current.onloadedmetadata = () => {
        videoRef.current.play().catch(error => {
          console.error('Error playing video:', error);
          setCameraError('Unable to play video stream');
        });
      };
    }
  } catch (error) {
    console.error('Camera access error:', error);
    
    // Detailed error handling
    switch (error.name) {
      case 'NotAllowedError':
        setCameraError('Camera access was denied. Please check your browser permissions.');
        break;
      case 'NotFoundError':
        setCameraError('No camera found on this device.');
        break;
      case 'NotReadableError':
        setCameraError('Camera is already in use or blocked.');
        break;
      case 'OverconstrainedError':
        setCameraError('Requested camera settings are not supported.');
        break;
      default:
        setCameraError(`Unable to access camera: ${error.message}`);
    }
  }
};


  const closeScanner = () => {
    // Stop video stream
    if (videoRef.current && videoRef.current.srcObject) {
      const tracks = videoRef.current.srcObject.getTracks();
      tracks.forEach(track => track.stop());
    }
    setShowQrScanner(false);
    setCameraError(null);
  };



  return (
    <>
      {/* Navigation Bar */}
      <nav className="bg-white shadow-md px-2 py-2 h-14">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <div  onClick={() => navigate('/supplier/home')} 
          className="flex items-center">
            <img src={Logo} alt="BrickBucket Logo" className="h-8 sm:h-10" />
          </div>
          
          {/* Right Side Icons Container */}
          <div className="flex items-center space-x-4">
          {/* <button onClick={handleQrCodeClick}>
              <FaQrcode className="text-[#D64541] h-5 w-5" />
            </button>*/}


            {/* Notification Bell with  Conditionally render notification count */}
           {/*  <button
      className="relative hover:bg-gray-100 p-2 rounded-full transition-colors duration-200"
      onClick={() => navigate('/supplier/notifications')}
    >
      <img src={Bell} className="h-5 w-5 text-[#D64541]" />
      {location.pathname !== '/supplier/notifications' && NotificationsCount > 0 && (
        <span className="bg-[#D64541] rounded-full text-sm text-white absolute top-1 right-1.5 block h-2.5 w-2.5  rounded-full flex items-center justify-center">
          
        </span>
      )}
    </button> */}
            
            {/* Hamburger Menu Icon */}
            <button
              onClick={toggleMenu}
              className="text-gray-700 focus:outline-none hover:bg-gray-100 p-2 rounded-full transition-colors duration-200"
            >
              {menuOpen ? (
                <FaTimes className="h-5 w-5" />
              ) : (
                <FaBars className="h-5 w-5" />
              )}
            </button>
          </div>
        </div>
      </nav>

      {/* Slide-out Menu */}
      <div 
        className={`fixed top-0 right-0 h-full w-64 bg-white shadow-lg transform transition-transform duration-300 ease-in-out z-50 ${
          menuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="p-5">
          <div className="flex justify-end">
            <button onClick={toggleMenu} className="text-gray-700">
              <FaTimes className="h-6 w-6" />
            </button>
          </div>
          
          <div className="mt-8 space-y-4">
            <div 
              onClick={() => navigate('/supplier/home')} 
              className="flex items-center p-3 rounded-md hover:bg-gray-100 cursor-pointer"
            >
              <FaHome className="mr-3 text-[#D64541]" />
              <span className="text-gray-700">{t.home}</span>
            </div>
            <div 
              onClick={() => navigate('/supplier/orders')}
              className="flex items-center p-3 rounded-md hover:bg-gray-100 cursor-pointer"
            >
              <FaClipboardList className="mr-3 text-[#D64541]" />
              <span className="text-gray-700">{t.orders}</span>
            </div>
             <div 
              onClick={() => navigate('/supplier/rfqs')}
              className="flex items-center p-3 rounded-md hover:bg-gray-100 cursor-pointer"
            >
              <FaFileInvoice className="mr-3 text-[#D64541]" />
              <span className="text-gray-700">{t.rfqs}</span>
            </div>
            <div 
              //onClick={() => navigate('/supplier/orders')} 
              className="flex items-center p-3 rounded-md hover:bg-gray-100 cursor-pointer"
            >
              <FaRupeeSign className="mr-3 text-[#D64541]" />
              <span className="text-gray-700">{t.payments}</span>
            </div>
            <div 
              onClick={() => navigate('/supplier/profile')}
              className="flex items-center p-3 rounded-md hover:bg-gray-100 cursor-pointer"
            >
              <FaUser className="mr-3 text-[#D64541]" />
              <span className="text-gray-700">{t.profile}</span>
            </div>
            <div 
              className="flex items-center p-3 rounded-md hover:bg-gray-100 cursor-pointer"
              onClick={handleLogout}
            >
              <FaSignOutAlt className="mr-3 text-[#D64541]" />
              <span className="text-gray-700">{t.logout}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Overlay when menu is open */}
      {menuOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={toggleMenu}
        ></div>
      )}

       {/* QR Scanner Modal */}
  {/* QR Scanner Modal */}
        {showQrScanner && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg p-4 relative w-full max-w-md max-h-[80vh]">
            {/* Close Button */}
            <button 
              onClick={closeScanner}
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-900"
            >
              <FaTimes className="h-6 w-6" />
            </button>
            
            <h2 className="text-xl font-semibold mb-4 text-center">Scan QR Code</h2>
            
            {/* Camera View or Error Message */}
            {cameraError ? (
              <div className="text-center text-red-500 p-4">
                <p>{cameraError}</p>
                <button 
                  onClick={handleQrCodeClick}
                  className="mt-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                >
                  Retry Camera Access
                </button>
              </div>
            ) : (
              <div className="relative w-full aspect-video bg-black">
                <video 
                  ref={videoRef}
                  autoPlay 
                  playsInline
                  muted
                  className="w-full h-full object-cover"
                />
              </div>
            )}
            
            <p className="text-center text-sm text-gray-600 mt-4">
              Position the QR code within the camera view
            </p>
          </div>
        </div>
      )}
    </>
  );
}

export default SupplierHeader;
